import { AdminApiService } from '../services';

export type GetMessagesFilter = { contactId?: string };

const MAX_MESSAGES_LIMIT = 500;

export const getMessages = async (
  filter?: GetMessagesFilter,
  sort: SortDirection = 'desc'
) => {
  if (!filter?.contactId) return null;

  return AdminApiService.getMessageHistoryApiAdminContactsContactIdMessageHistoryGet(
    filter.contactId,
    MAX_MESSAGES_LIMIT,
    0,
    null,
    sort
  );
};

export type { MessageHistoryEntry as MessageItem } from '../services';
